import * as React from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import { media } from 'src/utils.js'
import { ConfiguratorBox } from 'src/components/containers/configurator/ConfiguratorBox'
import { StoreProps } from 'src/stores'
import { observer, inject } from 'mobx-react'
import Calendar from 'src/components/atoms/input/Calendar'
import DropDown from 'src/components/atoms/input/Dropdown'
import Link from 'src/components/atoms/input/buttons/Link'
import IconText from 'src/components/atoms/IconText'

const mailIcon = require('src/assets/envelope.png')
const whatsappIcon = require('src/assets/whatsapp.png')

interface Props extends StoreProps {
  location: any
  history: any
  match: any
}

@inject('confStore')
@observer
export class Appointment extends React.Component<Props, any> {
  constructor(props) {
    super(props)
    this.state = {
      date: null,
      timeOfDay: null,
      type: null
    }
  }

  sendRequest = () => {
    const { confStore, history } = this.props
    const { date, timeOfDay, type } = this.state
    const offer = confStore.getOffer
    confStore.scheduleAppointment(type, timeOfDay, date)
    history.push(`/planung/vorsorge/termin/bestaetigung/${offer.uuid}`)
  }

  render() {
    const { confStore } = this.props
    const { date, timeOfDay, type } = this.state

    const offer = confStore.getOffer

    const transformedDate = date ? new Date(date) : date

    const today = new Date()
    const minDate = new Date()
    minDate.setDate(today.getDate() + 1)
    const maxDate = new Date()
    maxDate.setDate(today.getDate() + 31 * 3)

    const isWeekday = (date: Date) => {
      const day = date.getDay()
      return day !== 0 && day !== 6
    }

    const daytimes = [
      { key: 'MORNING', value: 'Morgens' },
      { key: 'MIDDAY', value: 'Mittags' },
      { key: 'AFTERNOON', value: 'Nachmittags' },
      { key: 'ALL_DAY', value: 'Ganztägig' }
    ]

    const meetingtype = [
      { key: 'PHONE', value: 'Telefonisch' },
      { key: 'PERSONAL', value: 'Persönliche Beratung' }
    ]

    const confirmDisabled = !(timeOfDay && type)

    return (
      <ConfiguratorBox title='Termin vereinbaren'>
        <p>
          Gerne beraten wir Sie zu allen Themen rund um Ihre
          Bestattungsvorsorge. Im Rahmen eines Telefonates oder bei einem
          persönlichen Termin nehmen wir uns Zeit, Sie ausführlich und völlig
          kostenlos zu beraten.
        </p>
        <p>
          Nachdem Sie die Anfrage abgeschickt haben, werden wir uns telefonisch
          bei Ihnen melden, um den Termin zu bestätigen. Wir bitten um
          Verständnis, dass dies ein paar Minuten dauert.
        </p>
        <FormAlign>
          <Calendar
            date={transformedDate}
            minDate={minDate}
            maxDate={maxDate}
            filter={isWeekday}
            onChange={(d) =>
              this.setState({ date: d ? d.toISOString() : null })
            }
          />
          <DropDown
            items={daytimes}
            onSelect={(t) => this.setState({ timeOfDay: t.target.value })}
            placeholder='Tageszeit wählen'
          />
          <DropDown
            items={meetingtype}
            onSelect={(t) => this.setState({ type: t.target.value })}
            placeholder='Art der Beratung'
          />
        </FormAlign>
        <Link onClick={this.sendRequest} disabled={confirmDisabled}>
          Anfrage abschicken
        </Link>
        <p>
          Bei Fragen zu Ihrer Bestattungsvorsorgeplanung oder zur
          Terminvereinbarung für Ihr persönliches Beratungsgespräch können Sie
          sich jederzeit gerne an uns wenden:
        </p>
        <IconsAlign>
          <IconText icon={mailIcon}>
            <a href='mailto:kontakt@benu.at'>E-Mail an kontakt@benu.at</a>
          </IconText>
          <IconText icon={whatsappIcon}>
            <a
              href={`https://wa.me/43800884404?text=Meine%20Vollmacht%20zum%20Angebot%20"${offer.orderId}"`}
              target='_blank'>
              WhatsApp an 0800884404
            </a>
          </IconText>
        </IconsAlign>
      </ConfiguratorBox>
    )
  }
}

const FormAlign = styled.div`
  display: flex;
  max-width: 800px;
  width: 100%;
  margin: auto;
  margin-bottom: 10px;
  padding: 0;
  justify-content: center;
  align-items: center;

  & > * {
    flex: 1 1 30%;
    margin: 7.5px;
    width: 100%;
  }

  ${media.tablet`
    flex-direction: column;
    padding: 0 15%;
  `}
  ${media.phone`
    padding: 0 5%;
  `}
`

const IconsAlign = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
`

export default withRouter(Appointment)



// WEBPACK FOOTER //
// ./src/components/organisms/checkout/Appointment.tsx